import PropTypes from "prop-types";
import classNames from "classnames";

const IconUnfollow = ({ className, height = "32px", width = "32px" }) => {
    const classes = classNames("unfollowIcon", className);
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            className={classes}
        >
            <g fillRule="evenodd">
                <path d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M23.6470588,15 L8,15 L8,18 L23.6470588,18 L23.6470588,15 Z"></path>
            </g>
        </svg>
    );
};

IconUnfollow.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconUnfollow;
